// React for Website

import React, { useEffect, useState } from "react";
//outsource
import { Select } from "antd";

//components

const SearchStaff = ({ data, onSelect }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------
  const [search, setSearch] = useState("");
  const [converted, setConverted] = useState([]);
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    setConverted(convertData(data));
  }, [data]);

   const filteredOptions = search
    ? converted.filter((option) =>
        option.label.toLowerCase().includes(search.toLowerCase())
      )
    : [];
  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  // const converted = search ? convertData(data) : [{ label: "", value: "" }];
  return (
   <Select
      style={{ width: "100%" }}
      showSearch
      placeholder="Search by staff mobile or email address"
      options={filteredOptions}
      filterOption={false} // Tắt bộ lọc mặc định để dùng bộ lọc tùy chỉnh
      onSearch={(value) => setSearch(value)}
      onSelect={(value) => {
        onSelect(value);
        setSearch("");
      }}
    />
  );
};

export default SearchStaff;

const convertData = (data) => {
  const newData = data?.map((item) => {
    // thay thế +64 thành 0
    const phoneNumber = item?.phone?.toString();
    let phone = "";
    if (phoneNumber) {
      if (phoneNumber.slice(0) === "+") {
        phone = `0${phoneNumber.slice(4)}`;
      } else {
        phone = `0${phoneNumber.slice(3)}`;
      }
    }
    const label = `${item?.firstName} ${item?.lastName} | ${phone} | ${item?.email}`;
    const value = item?.id;

    return {
      label,
      value,
    };
  });

  return newData;
};
